const CARDS_PER_PAGE = 9;

export default class PostsGrid {


	// Constructor
	constructor(asscroll, cursor, element) {

		this.asscroll = asscroll;
		this.asscrollCurrentPos = 0;
		this.asscrollElement = (asscroll) ? asscroll.scrollElements : null;

		this.cursor = cursor;

		this.element = element;
		this.data = JSON.parse(this.element.querySelector('.data').innerHTML);

		this.more = this.element.querySelector('.section-posts-grid--more');
		this.moreButton = this.more.querySelector('button');
		this.cardsContainer = this.element.querySelector('.section-posts-grid--cards');
		this.noResults = this.cardsContainer.querySelector('p');

		this.keywordInput = this.element.querySelector('.section-posts-grid--input input');
		this.keyword = this.keywordInput.value.toLowerCase();

		this.categoriesButton = this.element.querySelector('.section-posts-grid--button-categories');
		this.categoriesButtonText = this.categoriesButton.querySelector('span');
		this.categoriesAll = this.categoriesButtonText.innerHTML;
		this.categoryId = null;

		this.authorsButton = this.element.querySelector('.section-posts-grid--button-authors');
		this.authorsButtonText = this.authorsButton.querySelector('span');
		this.authorsAll = this.authorsButtonText.innerHTML;
		this.authorId = null;

		this.panel = document.createElement('div');
		this.panel.className = 'section-posts-grid--panel';
		this.panel.innerHTML = '<button><span class="screen-reader-text">Close</span></button><div><div><button class="section-posts-grid--close"><svg class="svg svg-icon-close"><use xlink:href="#icon-close"></use></svg><span class="screen-reader-text">Close</span></button><div></div></div></div>';
		this.panel.setAttribute('aria-hidden', 'true');
		document.body.appendChild(this.panel);
		this.panelCloseButtons = Array.prototype.slice.call(this.panel.querySelectorAll('button'), 0);
		this.panelContent = this.panel.querySelector('div div div div');
		this.panelScroll = this.panel.querySelector('div');

		this.buttonClosePanel = this.buttonClosePanel.bind(this);
		this.buttonMoreClick = this.buttonMoreClick.bind(this);
		this.buttonCategoriesClick = this.buttonCategoriesClick.bind(this);
		this.buttonAuthorsClick = this.buttonAuthorsClick.bind(this);
		this.handlePanelKeyboardNavigation = this.handlePanelKeyboardNavigation.bind(this)

		// this.hashChanged = this.hashChanged.bind(this);
		this.inputChanged = this.inputChanged.bind(this);
		this.selectItem = this.selectItem.bind(this);

		this.cardCount = 0;
		this.cards = [];

		this.page = 1;
		this.returnFocusElement = null

		this.queryParams = new URLSearchParams(window.location.search)

		if (this.queryParams.has('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum'))
		}

		this.hashChanged();
	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.asscrollCurrentPos;
		delete this.asscrollElement;
		delete this.cardCount;
		delete this.cards;
		delete this.cardsContainer;
		delete this.cursor;
		delete this.data;
		delete this.element;
		delete this.keyword;
		delete this.keywordInput;
		delete this.more;
		delete this.moreButton;
		delete this.noResults;
		delete this.panel;
		delete this.panelCloseButtons;
		delete this.panelContent;
		delete this.panelScroll;
		delete this.categoryId;
		delete this.categoriesAll;
		delete this.categoriesButton;
		delete this.categoriesButtonText;
		delete this.authorId;
		delete this.authorsAll;
		delete this.authorsButton;
		delete this.authorsButtonText;
	}
	enable() {
		this.disable();
		this.panelCloseButtons[0].addEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].addEventListener('click', this.buttonClosePanel);
		this.moreButton.addEventListener('click', this.buttonMoreClick);
		this.categoriesButton.addEventListener('click', this.buttonCategoriesClick);
		this.authorsButton.addEventListener('click', this.buttonAuthorsClick);
		this.panelContent.addEventListener('click', this.selectItem);
		this.keywordInput.addEventListener('input', this.inputChanged);
	}
	disable() {
		this.panelCloseButtons[0].removeEventListener('click', this.buttonClosePanel);
		this.panelCloseButtons[1].removeEventListener('click', this.buttonClosePanel);
		this.moreButton.removeEventListener('click', this.buttonMoreClick);
		this.categoriesButton.removeEventListener('click', this.buttonCategoriesClick);
		this.authorsButton.removeEventListener('click', this.buttonAuthorsClick);
		this.panelContent.removeEventListener('click', this.selectItem);
		this.keywordInput.removeEventListener('input', this.inputChanged);
	}


	// Event Handlers
	buttonClosePanel(event) {
		event.preventDefault();
		if (this.asscroll) {
			this.asscroll.disable();
			this.asscroll.currentPos = this.asscrollCurrentPos;
			this.asscroll.enable({ newScrollElements: this.asscrollElement });
		}
		this.panel.classList.remove('show');
		this.panel.setAttribute('aria-hidden', 'true');

		window.removeEventListener('keyup', this.handlePanelKeyboardNavigation)
		this.returnFocus()

	}
	buttonMoreClick(event) {
		event.preventDefault();

		this.page += 1
		this.queryParams.set('pnum', this.page)

		window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
		this.isPageUpdate = true

		this.addCards();
	}
	buttonCategoriesClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.categoryId === null ? 'active' : '' }" data-type="category" data-id=""><span>${ this.categoriesAll }</span></button>`;

		html += this.data.categories.map((category) => {
			return `<button class="${ this.categoryId === category.id ? 'active' : '' }" data-type="category" data-id="${ category.id }"><span>${ category.title }</span></button>`;
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}
		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');

		this.focusActive(event.target)
	}

	buttonAuthorsClick(event) {
		event.preventDefault();

		var html = `<button class="${ this.authorId === null ? 'active' : '' }" data-type="author" data-id=""><span>${ this.authorsAll }</span></button>`;

		html += this.data.authors.map((author) => {
			return `<button class="${ this.authorId === author.id ? 'active' : '' }" data-type="author" data-id="${ author.id }"><span>${ author.title }</span></button>`;
		}).join('')

		this.panelContent.innerHTML = html;

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panelScroll, reset: true });
		}

		this.panel.classList.add('show');
		this.panel.setAttribute('aria-hidden', 'false');

		this.focusActive(event.target)
	}

	focusActive(returnFocusElement) {

		this.returnFocusElement = returnFocusElement

		let activeOption = this.panel.querySelector('.active')
		if (activeOption) {
			activeOption.focus()
			this.asscroll.scrollTo(activeOption.getBoundingClientRect().top)
		}

		window.addEventListener('keyup', this.handlePanelKeyboardNavigation)
	}

	returnFocus() {
		if (this.returnFocusElement) {
			this.returnFocusElement.focus()
		}
	}

	handlePanelKeyboardNavigation(e) {

		// User hit escape. Close the panel
		if (e.keyCode == 27) {
			return this.buttonClosePanel(e)
		}

	  let focasables;
	  if (e.key == 'Tab') {
	    focasables = this.panel.querySelectorAll("a, input, select, button");

	    if (focasables) {
	      const firstElem = focasables[0];
	      const lastElem = focasables[(focasables.length - 1)];
	      if (e.target == firstElem && e.shiftKey) {
	        e.preventDefault();
	        lastElem.focus();
	      } else if (e.target == lastElem && !e.shiftKey) {
	        e.preventDefault();
	        firstElem.focus();
	      }
	    }
	  }
	}

	hashChanged() {

		// Prevent filter updates when just updating the page
		if (this.isPageUpdate === true) {
			this.isPageUpdate = null
			return;
		}

		var i, l;

		var categoryId = null;
		var authorId = null;
		var tagSlug = null;
		var categoryName = this.categoriesAll;
		var authorName = this.authorsAll;

		if (this.queryParams.has('category')) {
			let categoryParamId = this.queryParams.get('category')
			categoryId = (categoryParamId === '') ? null : parseInt(categoryParamId);

			if (categoryId !== null) {
				let category = this.data.categories.find((category) => category.id === categoryId)
				if (category) {
					categoryName = category.title
				}
			}
		}

		if (this.queryParams.has('author')) {
			let authorParamId = this.queryParams.get('author')
			authorId = (authorParamId === '') ? null : authorParamId;

			if (authorId !== null) {
				let author = this.data.authors.find((author) => author.id === authorId)
				if (author) {
					authorName = author.title
				}
			}
		}

		if (this.queryParams.has('tag')) {
			let tagParam = this.queryParams.get('tag')
			tagSlug = (tagParam === '') ? null : tagParam;
		}

		if (this.queryParams.get('pnum')) {
			this.page = parseInt(this.queryParams.get('pnum')) || 1;
		}

		this.categoriesButtonText.innerHTML = categoryName;
		this.authorsButtonText.innerHTML = authorName;

		this.categoryId = categoryId;
		this.authorId = authorId;
		this.tagSlug = tagSlug
		this.updateCards();
	}
	inputChanged(event) {
		this.keyword = event.currentTarget.value.toLowerCase();
		this.hashChanged();
	}
	selectItem(event) {
		event.preventDefault();
		var button = event.target;
		if (button.tagName !== 'BUTTON') {
			button = button.parentNode;
		}
		if (button.tagName === 'BUTTON') {
			var type = button.getAttribute('data-type');
			var id = button.getAttribute('data-id');

			this.queryParams.set(type, id)

			// Reset the page on filter change
			this.queryParams.set('pnum', 1)

			window.history.replaceState({}, '', `${ window.location.pathname }?${ this.queryParams.toString() }`)
			this.hashChanged()
		}
		this.buttonClosePanel(event);
	}


	// Helpers
	addCards() {

		let limit = CARDS_PER_PAGE * this.page

		// add our cards
		for (var i=this.cardCount, l=limit; i<l; i++) {
			this.cardCount += 1;
			if (i < this.cards.length) {
				this.addCard(this.cards[i]);
			}
		}

		// hide/show more button
		if (this.cardCount >= this.cards.length) {
			this.more.classList.add('hide');
		} else {
			this.more.classList.remove('hide');
		}

		if (this.asscroll) {
			this.asscroll.resize()
		}

		// Update our cursor hovers
		if (this.cursor) {
			this.cursor.updateHovers();
		}

	}

	addCard(item) {
		this.cardsContainer.insertAdjacentHTML('beforeend', item.card);
	}

	updateCards() {

		var i, l, match;


		let filters = [];

		if (this.authorId != null) {
			filters.push({ key: 'authors', value: this.authorId })
		}

		if (this.categoryId != null) {
			filters.push({ key: 'categories', value: this.categoryId })
		}

		if (this.tagSlug != null) {
			filters.push({ key: 'tags', value: this.tagSlug })
		}

		var posts = this.data.posts.filter((post) => {

			if (filters.length == 0 && !this.keyword) {
				return true;
			}

			let match = !this.keyword || this.keyword && post.keywords.includes(this.keyword)
			return match && filters.every((filter) => post[filter.key].includes(filter.value))
		})

		this.cardCount = 0;
		this.cards = [];
		this.cardsContainer.innerHTML = '';
		this.more.classList.add('hide');
		if (posts.length === 0) {
			this.cardsContainer.appendChild(this.noResults);
		} else {
			this.cards = posts;
			this.addCards();
		}
	}
}
